import { cn } from "@/lib/utils";
import { AiFillYoutube } from "react-icons/ai";
import { BsDiscord } from "react-icons/bs";

function MiniIcon({ type, className, offset = "0", size = "1em" }: { type: "youtube" | "discord", className?: string, offset?: string, size?: string }) {
    return (
        <div
            style={ {
                left: offset,
                bottom: offset
            } }
            className={
                cn("absolute rounded-full p-1 bg-zinc-950 hover:bg-nfPurple-800 peer-hover:bg-nfPurple-800 transition-colors shadow-md -shadow-y-0.5 shadow-black/50 border border-nfPurple-700",
                    className
                ) }>
            { type == "youtube" && <AiFillYoutube color="red" size={ size } /> }
            { type == "discord" && <BsDiscord color="#7289da" size={ size } /> }
        </div>
    )
}
export default MiniIcon